<template>
  <div class="dispatch-map">
    <div id="container">
      <div class="map-center-box">
        <div class="chatting">
          <van-loading size="14" v-if="getCenterLoading">加载中...</van-loading>
          <span v-else>{{mapCenterInfo.title}}</span>
        </div>
        <van-image
          width="22"
          height="39"
          :src="require(queryParams.type&&queryParams.type==1?'/src/assets/image/start-addr-icon.png':'/src/assets/image/end-addr-icon.png')"
        />
      </div>
    </div>
    <address-info ref="addressInfo" :mapCenterInfo="mapCenterInfo" :openSearch.sync="openSearch" :queryParams.sync="queryParams" />
    <search-list ref="searchList" :map="map" :locationPhoneInfo="locationPhoneInfo" :showIdentification.sync="showIdentification" :getCenterLoading.sync="getCenterLoading" :mapCenterInfo.sync="mapCenterInfo" :openSearch.sync="openSearch" :queryParams="queryParams" @getMapCenter="getMapCenter" />
    <address-identification :showIdentification.sync="showIdentification" ref="addressIdentification" @confirm="identificationConfirm" />
  </div>
</template>

<script>
import { geocoder } from '@/api/dispatch/index.js';
import addressInfo from '@/view/line/components/address-info.vue';
import searchList from '@/view/line/components/search-list.vue';
import addressIdentification from '@/view/line/components/address-identification.vue';
import { Image , Loading , Search } from 'vant';
export default {
  components:{ 
    addressInfo , 
    searchList,
    addressIdentification,
    [Image.name]: Image,
    [Loading.name]: Loading,
    [Search.name]: Search,
   },
  data(){
     return {
      map:null,
      mapZoomAntiShakeTimer:null,  //地图缩放防抖计时器
      mapCenterInfo:{},  //当前地图中心数据
      getCenterLoading:false,  //获取中心点loading
      openSearch:false,  //地址搜索栏
      showIdentification:false,  //显示地址识别框
      //手机当前位置
      locationPhoneInfo:{
        province:'',  //省
        city:'',  //市
        district:'',  //区
        detailedAddress:'',  //详细地址
        title:'',  //标题
        latitude:'',
        longitude:'',
      },
      queryParams:{
        id:null,
        province:'',
        city:'',
        district:'',
        detailedAddress:'',
        factoryLinkPhone:'',
        factoryLinkName:'',
        remark:'',
        title:'',
        latitude:'',
        longitude:'',
        factoryName:'',
        type:1
      },
    }
  },
  watch:{
    mapCenterInfo:{
      handler(val){
        Object.assign(this.queryParams,val);
      },
      deep:true,
      immediate:true
    }
  },
  beforeCreate(){
    let query = this.$route.query;
    // if(query.id) pagesTital = `编辑${query.type==1?'起点信息':'终点信息'}`;
    // else pagesTital = `新增${query.type==1?'起点信息':'终点信息'}`;
    // document.title = pagesTital;
    document.title = `线路${query.type==1?'起点信息':'终点信息'}`
  },
  created(){
    this.initData();
  },
  async mounted(){
    await this.createMap();
    this.initMap();
  },
  methods:{
    /** 数据初始化 */
    initData(){
      let query = this.$route.query;
      this.queryParams = {
        id:query.id?query.id:null,
        factoryLinkPhone:query.factoryLinkPhone?query.factoryLinkPhone:'',
        factoryLinkName:query.factoryLinkName?query.factoryLinkName:'',
        remark:query.remark?query.remark:'',
        type:query.type?query.type:1,
        factoryName:query.factoryName?query.factoryName:'',
      };
      this.mapCenterInfo = {
        province:query.province?query.province:'',
        city:query.city?query.city:'',
        district:query.district?query.district:'',
        detailedAddress:query.detailedAddress?query.detailedAddress:'',
        title:query.title?query.title:'',
        latitude:query.latitude?query.latitude:'',
        longitude:query.longitude?query.longitude:'',
      };
    },
    /** 地址识别确认 */
    identificationConfirm(params){
      Object.assign(this.queryParams,{
        factoryLinkName:params.factoryLinkName,
        factoryLinkPhone:params.factoryLinkPhone,
        remark:params.remark
      })
      this.openSearch = true;
      this.$nextTick(()=>{
        this.$refs['searchList'].searchValue = params.detailedAddress.replace(/\s/g,'');
        this.$refs['searchList'].getList();
      })
    },
    initMap(){
        if(this.map) return ;
        let query = this.$route.query;
        let LatLng = {};
        let isLocationPhone = false;
        if(query.latitude&&query.longitude) LatLng = { latitude:query.latitude , longitude:query.longitude };
        else if(query.locationPhoneLat&&query.locationPhoneLng) {
          LatLng = { latitude:query.locationPhoneLat , longitude:query.locationPhoneLng };
          isLocationPhone = true;
        }else LatLng = { latitude: '22.543099' , longitude: '114.057868' };
        var center = new window.TMap.LatLng(LatLng.latitude, LatLng.longitude);
        //初始化地图
        this.map = new window.TMap.Map("container", {
            rotation: 0,//设置地图旋转角度
            pitch: 0, //设置俯仰角度（0~45）
            zoom: 17,//设置地图缩放级别
            center: center//设置地图中心点坐标
        });
        this.map.on('zoom',this.mapZoom);
        this.map.on('dragend',this.mapDragend);
        this.$refs['searchList'].mountPanend(this.map)
        this.getMapCenter({notSetCenterInfo:query.title?true:false})
        .then(result=>{
          if(isLocationPhone) {
            this.locationPhoneInfo = {
              province:result.address_component.province,  //省
              city:result.address_component.city,  //市
              district:result.address_component.district,  //区
              detailedAddress:result.pois[0].address,  //详细地址
              title:result.pois[0].title,  //标题
              latitude:result.location.lat,
              longitude:result.location.lng,
            }
          }
        })
    },
    // 地图缩放事件
    mapZoom(){
      if(this.mapZoomAntiShakeTimer){
          clearTimeout(this.mapZoomAntiShakeTimer);
          this.mapZoomAntiShakeTimer = null;
      }
      this.mapZoomAntiShakeTimer = setTimeout(()=>this.getMapCenter(),200)
    },
    // 地图拖拽交互结束时触发
    mapDragend(){
      this.getMapCenter();
    },
    async getMapCenter(options){
      try {
        this.getCenterLoading = true;
        let lat,lng;
        if(options&&options.LatLng) {
          lat = options.LatLng.lat;
          lng = options.LatLng.lng;
        }else {
          let centerData = this.map.getCenter();
          lat = centerData.lat;
          lng = centerData.lng;
        }
        let { result } = await geocoder({location:`${lat},${lng}`,get_poi:1,poi_options:'policy=1'});
          if(!result.pois.length) {
            this.mapCenterInfo = {
                province:'',  //省
                city:'',  //市
                district:'',  //区
                detailedAddress:'',  //详细地址
                title:'移动以获取位置',  //标题
                latitude:result.location.lat,
                longitude:result.location.lng,
                adcode:result.ad_info.adcode //地区编码
            };
            return Promise.reject(result)
          }
          if(!(options&&options.notSetCenterInfo)){
            this.mapCenterInfo = {
              province:result.address_component.province,  //省
              city:result.address_component.city,  //市
              district:result.address_component.district,  //区
              detailedAddress:result.pois[0].address,  //详细地址
              title:result.pois[0].title,  //标题
              latitude:result.location.lat,
              longitude:result.location.lng,
              adcode:result.ad_info.adcode //地区编码
            };
          }
        this.getCenterLoading = false;
        return Promise.resolve(result)
    } catch (error) {
        this.getCenterLoading = false;
        return Promise.reject(error);
    }
  },
  }
}
</script>

<style scoped lang="scss">
  .dispatch-map {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    #container {
      flex: 1;
      overflow: hidden;
      position: relative;
      .map-center-box {
        position: absolute;
        left: 50%;
        bottom: 50%;
        transform: translateX(-50%);
        z-index: 9;
        display: flex;
        flex-direction: column;
        align-items: center;
        .chatting {
          box-sizing: border-box;
          // background: url('/src/assets/image/chatting.png') no-repeat left top;
          min-height: 40px;
          overflow: hidden;
          background: url('../../assets/image/chatting.png') no-repeat left top;
          background-size: 100% 100%;
          padding: 10px 10px 16px 10px;
          font-size: 14px;
          word-break: keep-all;
        }
      }
    }
  }
  
</style>